import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'

export default () => {
  const cartButton = document.querySelector('.js-woo-cart-button')
  if (!cartButton) return

  const popup = document.querySelector('.js-woocommerce-popup')
  const close = document.querySelector('.js-woocommerce-popup-close')
  const overlay = document.querySelector('.js-woocommerce-popup-overlay')
  const message = document.querySelector('.woocommerce-message')
  const cartForm = document.querySelector('form.cart')
  const widthInput = cartForm.querySelector('.js-woo-width')
  const lengthInput = cartForm.querySelector('.js-woo-length')

  cartButton.addEventListener('click', () => {
    sessionStorage.setItem('reloading', 'true')

    if (cartForm) {
      sessionStorage.setItem('mattador_width', widthInput.value)
      sessionStorage.setItem('mattador_length', lengthInput.value)
    }
  })

  if (close) {
    overlay.addEventListener('click', () => {
      closePopup(popup, message)
    })

    close.addEventListener('click', () => {
      closePopup(popup, message)
    })
  }

  function closePopup(popup, message) {
    popup.classList.remove('active')
    enableBodyScroll(popup)

    message.classList.add('fade')

    window.setTimeout(() => {
      message.classList.add('hide')
    }, 1000)
  }

  window.addEventListener('load', () => {
    let reloading = sessionStorage.getItem('reloading')
    if (reloading) {
      sessionStorage.removeItem('reloading')
      popup.classList.add('active')
      disableBodyScroll(popup)

      const priceInput = popup.querySelector('.js-woocommerce-popup-sizes')
      const width = sessionStorage.getItem('mattador_width')
      const height = sessionStorage.getItem('mattador_length')

      if (priceInput && width && length) {
        priceInput.innerHTML = `Afmeting: L: ${height} cm, B: ${width} cm`
      }
    } else {
      if (message) {
        message.classList.add('hide')
      }
    }
  })
}



// WEBPACK FOOTER //
// ./src/js/woocommerce/AddProductPopup.js